export class PaymentTypes {
    public constructor(init?: Partial<PaymentTypes>) {
      Object.assign(this, init);
    }
    paymentCode:string;
	  paymentDescription: string;
   }